<template>
  <div @click="click" @mouseover="over = true" @mouseleave="over = false" :style="style"
       style="border-radius: 4px; cursor: pointer; padding: 1px 0">
    <slot :check="check" :over="over"></slot>
  </div>
</template>

<script>
  export default {
    name: 'StatisticsRadio',
    props: {
      label: {
        type: [String,
          Number
        ],
        default: null
      }
    },
    data () {
      return {
        over: false
      }
    },
    methods: {
      click () {
        if (this.label != null && this.statisticsRadioGroup) {
          this.statisticsRadioGroup.$emit('input', this.check ? null : this.label)
        }
      }
    },
    computed: {
      check () {
        return this.statisticsRadioGroup.value === this.label
      },
      style () {
        const checkOrOver = this.check || this.over
        return {
          'background-color': checkOrOver ? '#1890ff' : 'transparent',
          color: checkOrOver ? 'white' : '#333'
        }
      },
      statisticsRadioGroup () {
        let parent = this.$parent
        while (parent) {
          if (parent.$options.componentName === 'StatisticsRadioGroup') {
            return parent
          }
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>

<style scoped>

</style>
